import Layout from '@/layout';
var courierRouter = {
  path: '/courier',
  component: Layout,
  redirect: '/courier/index',
  name: 'Courier',
  meta: {
    title: '配送记录',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/courier/index');
    },
    name: 'CourierIndex',
    meta: {
      title: '配送记录',
      icon: ''
    }
  },
  // 配送门店 
  {
    path: 'courierShop',
    component: function component() {
      return import('@/views/courier/courierShop');
    },
    name: 'CourierShop',
    meta: {
      title: '配送门店',
      icon: ''
    }
  },
  // 配送设置
  {
    path: 'courierSet',
    component: function component() {
      return import('@/views/courier/courierSet');
    },
    name: 'CourierSet',
    meta: {
      title: '配送设置',
      icon: ''
    }
  }]
};
export default courierRouter;